import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import TextInput from './TextInput/TextInput';
import { Button } from './Button';
import Select from './Select/Select';
import PhoneNumberInput from './PhoneNumberInput/PhoneNumberInput';
import { booktrailApi } from '../api/booktrail';

const classOptions = [
  { value: 'Class 1', label: 'Class 1' },
  { value: 'Class 2-3', label: 'Class 2-3' },
  { value: 'Class 4-6', label: 'Class 4-6' },
  { value: 'Class 7-9', label: 'Class 7-9' },
  { value: 'Class 10-12', label: 'Class 10-12' },
  { value: 'Bachelors Degree', label: 'Bachelors Degree' },
  { value: 'Masters Degree', label: 'Masters Degree' },
  { value: 'Doctorate/Ph.D', label: 'Doctorate/Ph.D' },
   { value: 'others', label: 'Others' }
];

const EnquiryForm = () => {
  const { register, handleSubmit,  reset, formState: { errors } } = useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [number,setNumber] = useState('')

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      const result = await booktrailApi.booktrail({ ...data, number });
      if (result) {
        reset();
        navigate('/thank-you', { replace: true });
      }
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-5 lg:p-6  ">
      <h3 className="text-2xl font-bold text-gray-800 text-center mb-6">Book your Free Trial</h3>
      <form className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          label="Parent's Name"
          name="parentName"
          register={register}
          errors={errors}
          required
          placeholder="Parent's Name"
        />
        <TextInput
          label="Parent's Email"
          name="parentEmail"
          type="email"
          register={register}
          errors={errors}
          required
          placeholder="Parent's Email"
        />
         <TextInput
          label="Subject"
          name="subject"
          type="subject"
          register={register}
          errors={errors}
          required
          placeholder="enter subject"
        />
           <div className="py-3 flex flex-col lg:flex-row lg:items-center items-start gap-4">
                <div className=" w-full flex flex-col">
                  <PhoneNumberInput value={number} containerStyle={{ margin: 0 }} setValue={setNumber} />
                </div>
              </div>
        {/* <Controller
          name="phone"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <PhoneNumberInput
              value={field.value}
              setValue={field.onChange}
            />
          )}
        /> */}
        <TextInput
          label="Child's Name"
          name="childName"
          register={register}
          errors={errors}
          required
          placeholder="Child's Name"
        />
        <Select
          label="Select Class"
          name="class"
          register={register}
          options={classOptions}
          required
        />
        <div>
                <p className="text-gray-700 mb-2">Do you have a Laptop/PC at home for class?</p>
                <div className="flex items-center space-x-6">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      {...register('device', {
                        required: true
                      })}
                      value="yes"
                      className="form-radio text-primary focus:ring-primary"
                    />
                    <span className="ml-2 text-gray-700">Yes</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      {...register('device', {
                        required: true
                      })}
                      value="no"
                      className="form-radio text-primary focus:ring-primary"
                    />
                    <span className="ml-2 text-gray-700">No</span>
                  </label>
                </div>
                {errors.device && <p className="mt-1 text-sm text-red-500">This field is required</p>}
              </div>
        <div className="text-white font-bold text-lg h-12">
          <Button
            text="Schedule a Free Trial"
            onClick={handleSubmit(onSubmit)}
            bgColor="bg-secondary"
            loading={loading}
            fullWidth
          />
        </div>
      </form>
    </div>
  );
};

export default EnquiryForm;
